import { IState } from 'shared/store';

import { selectUserEmail } from '../offerData';

export const selectCurrentUserEmail = (state: IState): string => {
  const userEmail = selectUserEmail(state);

  return userEmail || '';
};
